import { jsxs as r, Fragment as t, jsx as C } from "react/jsx-runtime";
const l = () => /* @__PURE__ */ r(t, { children: [
  /* @__PURE__ */ C(
    "path",
    {
      d: "M19.707 16.293L16.414 13H18C18.404 13 18.77 12.756 18.924 12.383C19.078 12.009 18.993 11.579 18.707 11.293L15.414 8.00001H16C16.404 8.00001 16.77 7.75601 16.924 7.38301C17.078 7.00901 16.993 6.57901 16.707 6.29301L12.707 2.29301C12.316 1.90201 11.684 1.90201 11.293 2.29301L7.29299 6.29301C7.00699 6.57901 6.92199 7.00901 7.07599 7.38301C7.23099 7.75601 7.59599 8.00001 7.99999 8.00001H8.58599L5.29299 11.293C5.00699 11.579 4.92199 12.009 5.07599 12.383C5.23099 12.756 5.59599 13 5.99999 13H7.58599L4.29299 16.293C4.00699 16.579 3.92199 17.009 4.07599 17.383C4.23099 17.756 4.59599 18 4.99999 18H19C19.404 18 19.77 17.756 19.924 17.383C20.078 17.009 19.993 16.579 19.707 16.293Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ C("path", { d: "M14 18H10V23H14V18Z", fill: "currentColor" })
] });
export {
  l as default
};
